import { render } from "./IconShoppingCart.vue?vue&type=template&id=6e01ed68"
import script from "./IconShoppingCart.vue?vue&type=script&lang=js"
export * from "./IconShoppingCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__